import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import propTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';

const ReviewsPagesCountInfo = ({ className, fromNum, toNum, totalCount }) => {
    if (!toNum) {
        return null;
    }
    return (
        <div className={classnames(className, 'reviews-pages-count-info flex flex-between')}>
            <I18n k="reviews.general.total_count_info" params={{ fromNum, toNum, total: totalCount }} />
        </div>
    );
};

ReviewsPagesCountInfo.propTypes = {
    className: propTypes.string,
    fromNum: propTypes.number,
    toNum: propTypes.number,
    totalCount: propTypes.number,
};

const mapStateToProps = (state) => ({
    fromNum: 1,
    toNum: state.reviews?.length,
    totalCount: state.filteredTotalCount,
});

export default connect(mapStateToProps)(ReviewsPagesCountInfo);
